import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackClickedAssetModalTab } from "@air/analytics";
import { Info } from "@air/next-icons";
import { memo } from "react";
import { PanelTabButton } from "~/components/AssetModal/Panel/Tabs/components/PanelTabButton";
import { INFO_TAB } from "~/constants/testIDs";
import { AssetModalPanel, useAssetModalPanelContext } from "~/providers/AssetModalPanelContextProvider";
export const InfoTabButton = /*#__PURE__*/ memo(()=>{
    const { panel, togglePanel } = useAssetModalPanelContext();
    const { trackClickedAssetModalTab } = useTrackClickedAssetModalTab();
    return /*#__PURE__*/ _jsx(PanelTabButton, {
        isSelected: panel === AssetModalPanel.INFO,
        label: "Info",
        testId: INFO_TAB,
        onClick: (event)=>{
            event.stopPropagation();
            togglePanel(AssetModalPanel.INFO);
            trackClickedAssetModalTab({
                tab: AssetModalPanel.INFO,
                panelAction: panel ? panel === AssetModalPanel.INFO ? "close" : "switch" : "open"
            });
        },
        icon: /*#__PURE__*/ _jsx(Info, {
            className: "size-6"
        })
    });
});
InfoTabButton.displayName = "InfoTabButton";
